import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { BaseballCardProfileFragment } from '@minecraft.graphql-operations';
import { DetailTextLarge } from '@minecraft.atoms';
import { helpers } from '@minecraft.utils';

type UnionsProps = Pick<BaseballCardProfileFragment, 'talentUnions'>;

export const Unions = ({ talentUnions }: UnionsProps) => (
  <>
    {talentUnions?.length > 0 && (
      <DetailTextLarge as="div" testId="unions-text">
        {helpers.getUnionsString(talentUnions, true)}
      </DetailTextLarge>
    )}
  </>
);

const LoadingWrapper = (props: UnionsProps | { loading: true }) => {
  return 'loading' in props ? (
    <DetailTextLarge>
      <Skeleton />
    </DetailTextLarge>
  ) : (
    <Unions {...props} />
  );
};

export default LoadingWrapper;
